<!-- Left Hand Side -->
<div class="col-sm-3" id="locatetab">
	<div style="float: right; padding-top: 20px; padding-right: 4px">
		<ng-container *ngIf="isLocationMode == true">
			<span class="badge badge-warn">LOCATION MODE</span>
		</ng-container>
		<ng-container *ngIf="isLocationMode == false">
			<span class="badge badge-warn" style="float: right;">SELECT MODE</span>
		</ng-container>
		<ng-container>
			<!-- KHT 08/03/2021  - if user is in select mode, give them the option to filter with/without their selected assets-->
			<div *ngIf="mSelectedTabType == 'ASSETS' && !isLocationMode" style="font-size: small;
					padding-top: 20px;">
				<span class="checkbox"><input type="checkbox" class="styled" [(ngModel)]="keepSelectedAssetsInFilter"
						(ngModelChange)="refreshAssetTab()"><label for="checkbox">Include
						selected<br>assets in filter</label></span>
			</div>
			<div *ngIf="mSelectedTabType == 'ASSETS' && isLocationMode" style="font-size: small;
					padding-top: 20px;">
				<span class="checkbox"><input type="checkbox" class="styled" [(ngModel)]="includeAllAssets"
						(ngModelChange)="refreshAssetTab()"><label for="checkbox">Include
						all<br>assets in filter</label></span>
			</div>
			<!-- KHT 08/03/2021  - if user is in select mode, give them the option to filter with/without their selected people-->
			<div *ngIf="mSelectedTabType == 'PEOPLE' && !isLocationMode" style="font-size: small;
					padding-top: 20px;">
				<span class="checkbox"><input type="checkbox" class="styled" [(ngModel)]="keepSelectedPeopleInFilter"
						(ngModelChange)="refreshTab(mTabTypes.PEOPLE)"><label for="checkbox">Include
						selected<br>people in filter</label></span>
			</div>
			<div *ngIf="mSelectedTabType == 'PEOPLE' && isLocationMode" style="font-size: small;
					padding-top: 20px;">
				<span class="checkbox"><input type="checkbox" class="styled" [(ngModel)]="includeAllPeople"
						(ngModelChange)="refreshTab('PEOPLE')"><label for="checkbox">Include
						all<br>people in filter</label></span>
			</div>
		</ng-container>
	</div>

	<!-- Header -->
	<h1 class="locate-page-header"><i class="fa fa-search" aria-hidden="true"></i> LOCATE</h1>

	<!-- Tab Navigation (People/Assets/Vehicles -->
	<ul class="nav nav-tabs">
		<li (click)="tabChange(mTabTypes.LOCATIONS)" class="active"><a data-toggle="tab"
				href="#locate_locationsTab">LOCATIONS</a></li>
		<li (click)="tabChange(mTabTypes.PEOPLE)"><a data-toggle="tab" href="#locate_peopleTab">PEOPLE <span>({{ totalNumberOfPeople }}) [{{ getCheckedPeopleCountForDisplay() }}]</span></a></li>
		<li (click)="tabChange(mTabTypes.ASSETS)"><a data-toggle="tab" href="#locate_assetsTab">ASSETS <span>({{ totalNumberOfAssets }}) [{{ getCheckedAssetsCountForDisplay() }}]</span></a></li>
	</ul>

	<!-- Tab Content (Locations/People/Assets/Vehicles) -->
	<div class="tab-content tab-section" style="border: 0px solid">

		<!-- People Tab -->
		<div id="locate_locationsTab" class="tab-pane fade in active">

			<ng-container *ngIf="currentFilters[mTabTypes.LOCATIONS] && currentFilters[mTabTypes.LOCATIONS].length > 0">
				<div style="float: right" (click)="filterChosen(mTabTypes.LOCATIONS, null)">
					<i class="fa fa-close"></i>
				</div>
				<ng-container *ngFor="let currentLocationFilter of currentFilters[mTabTypes.LOCATIONS]">
					<div style="background-color: black; color: darkorange; align-content: center; padding-left: 20px">
						<i (click)="removeFilter(mTabTypes.LOCATIONS, currentLocationFilter)" style="color: red"
							class="fa fa-minus-circle"></i>&nbsp;<i class="fa fa-filter"></i>
						{{ currentLocationFilter.name }}
					</div>
				</ng-container>
			</ng-container>

			<!-- Location Tab - Search Bar -->
			<div class="input-group locate-input">
				<input [(ngModel)]="mLocationsSearchValue" (ngModelChange)="locationsSearchValueChanged()"
					class="form-control" placeholder="Search for locations...">
			</div>

			<!-- Location Tab - Location information -->
			<div class="locate-tab">
				<table class="table tablesorter tablesorter-default locate-table">

					<!-- Main Headers -->
					<tbody>
						<tr class="header">
							<th>NAME</th>
						</tr>
					</tbody>

					<!-- People Data -->
					<tbody id="locateTableLocations" *ngIf="mDisplayedLocationUis != null">

						<!-- Create the Displays for each Location -->
						<ng-container *ngFor="let ui of mDisplayedLocationUis">
							<ng-container *ngIf="ui.mLocation != null">

								<!-- Main Label (Displayed when not selected) -->

								<tr id="locationsLocateHeader_{{ ui.mLocation.id }}" class="locateHeader">
									<td (click)="locationClicked(ui)" [class.groupSelected]="isLocationSelected(ui)">
										<i class="fa fa-map"></i> {{ui.mLocation.name }}
									</td>
								</tr>

								<!-- Display Body (Displayed when selected) -->
								<ng-container *ngIf="ui.mLocation.zones && ui.mLocation.zones.length > 0">
									<div id="locationsLocateBody_{{ ui.mLocation.id }}"
										class="locateHeader section-select">
										<table border="0" width="100%">
											<ng-container *ngIf="mLocationUis[ui.mLocation.id] != null">
												<ng-container *ngFor="let loc2 of mLocationUis[ui.mLocation.id]">
													<!-- Level 2 location -->
													<tr>
														<td (click)="locationClicked(loc2, false, ui.mLocation.id)"
															[class.zoneSelected]="isLocationSelected(loc2)"
															style="padding-left: 50px; width: 100%">
															<i class="fa fa-map"></i> {{ loc2.mLocation.name }}
														</td>
													</tr>
													<ng-container *ngIf="mLocationUis[loc2.mLocation.id] != null">
														<ng-container
															*ngFor="let loc3 of mLocationUis[loc2.mLocation.id]">
															<!-- Level 3 location -->
															<tr>
																<td (click)="locationClicked(loc3, false, ui.mLocation.id)"
																	[class.zoneSelected]="isLocationSelected(loc3)"
																	style="padding-left: 100px; width: 100%">
																	<i class="fa fa-map"></i> {{ loc3.mLocation.name }}
																</td>
															</tr>
															<!-- Level 3 zone -->
															<ng-container *ngFor="let zone3 of loc3.mLocation.zones">
																<tr>
																	<td (hover)="zoneHover(zone3)"
																		(click)="zoneClicked(zone3)"
																		[class.zoneSelected]="isZoneSelected(zone3)"
																		style="padding-left: 50px; width: 100%">
																		<i class="fa fa-bullseye"></i> {{ zone3.name }}
																	</td>
																</tr>
															</ng-container>
														</ng-container>
													</ng-container>
												</ng-container>
											</ng-container>

											<ng-container *ngFor="let zone of ui.mLocation.zones">
												<!-- Level 2 zone -->
												<tr>
													<td (hover)="zoneHover(zone)" (click)="zoneClicked(zone)"
														[class.zoneSelected]="isZoneSelected(zone)"
														style="padding-left: 50px; width: 100%">
														<ng-container
															*ngIf="mSelectedLocation && (mSelectedLocation.id != ui.mLocation.id)">
															<span style="color: #333"><i class="fa fa-bullseye"></i>
																{{ zone.name }}</span>
														</ng-container>
														<ng-container
															*ngIf="mSelectedLocation && (mSelectedLocation.id == ui.mLocation.id)">
															<span><i class="fa fa-bullseye"></i> {{ zone.name }}</span>
														</ng-container>
													</td>
												</tr>
											</ng-container>
										</table>
									</div>
								</ng-container>
							</ng-container>
						</ng-container>

					</tbody>
				</table>
			</div>
		</div>
		<!-- End of Locations Tab -->

		<!-- People Tab -->
		<div id="locate_peopleTab" class="tab-pane fade in">


			<ng-container *ngIf="currentFilters[mTabTypes.PEOPLE] && currentFilters[mTabTypes.PEOPLE].length > 0">
				<div style="float: right" (click)="filterChosen(mTabTypes.PEOPLE, null)">
					<i class="fa fa-close"></i>
				</div>
				<ng-container *ngFor="let currentPeopleFilter of currentFilters[mTabTypes.PEOPLE]">
					<div style="background-color: black; color: darkorange; align-content: center; padding-left: 20px">
						<i (click)="removeFilter(mTabTypes.PEOPLE, currentPeopleFilter)" style="color: red"
							class="fa fa-minus-circle"></i>&nbsp;<i class="fa fa-filter"></i>
						{{ currentPeopleFilter.name }}
					</div>
				</ng-container>
			</ng-container>

			<!-- People Tab - Search Bar -->
			<div class="input-group locate-input">
				<input [(ngModel)]="mPeopleSearchValue" (ngModelChange)="peopleSearchValueChanged($event)"
					style="width: 75%" class="form-control" placeholder="Search for someone...">
				<select class="form-control" style="width: 25%" [(ngModel)]='mSelectedPeopleSearchType'
					(change)="peopleSearchTypeChanged()">
					<option *ngFor="let type of mSearchTypes" [ngValue]="type.value">
						{{type.title}}
					</option>
				</select>
			</div>

			<!-- People Tab - People information -->
			<div class="locate-tab">
				<div class="locate-tab-scroll">
				<table class="table tablesorter tablesorter-default locate-table">

					<!-- Main Headers -->
					<tbody>
						<tr class="header">
							<th style="width: 0px;">
								<div class="checkbox checkbox-inline"><input type="checkbox" id="allPeopleCheckbox"
										class="styled" [(ngModel)]="allPeopleSelected"
										(click)="selectAllPeople($event.target.checked)"><label
										for="allPeopleCheckbox"></label></div>
							</th>
							<th style="width: 0px;"></th>
							<th>NAME</th>
							<th>LOCATION</th>
							<th>ZONE</th>
						</tr>
					</tbody>

					<!-- People Data -->
					<tbody id="locateTablePeople">

						<!-- Create the Displays for each User -->
						<ng-container *ngFor="let ui of mDisplayedPeopleUis | paginate: {id: 'peopletype_pagination', itemsPerPage: resultsPerPageValues, currentPage: currentPeoplePage, totalItems: totalNumberOfPeople }">

							<!-- Main Label -->
							<tr id="{{getIdForPeopleLocateHeader(ui)}}"
								[class.groupSelected]="isPeopleGroupSelected(ui)" class="locateHeader">
								<td style="width: 16px">
									<div class="checkbox checkbox-inline"><input type="checkbox" class="styled"
											[(ngModel)]="ui.selected" [disabled]="!ui.person.locationInstance"
											(click)="selectPerson(ui, $event.target.checked)"><label
											for="checkbox"></label></div>
								</td>
								<td style="width: 16px" (click)="personHeaderClicked(ui)">
									<img [src]="getIconSourceForObjectInstance(ui.person)" />
								</td>
								<td (click)="personHeaderClicked(ui)">
									{{ui.person.name }}
								</td>
								<td (click)="personHeaderClicked(ui)">
									<ng-container *ngIf="ui.person.locationInstance != null">
										{{ui.person.locationInstance.name }}
									</ng-container>
									<ng-container *ngIf="ui.person.locationInstance == null">
										NOT PRESENT
									</ng-container>
								</td>

								<td (click)="personHeaderClicked(ui)">
									<ng-container *ngIf="ui.person.zoneInstance != null">
										{{ui.person.zoneInstance.name }}
									</ng-container>
								</td>
							</tr>

							<!-- Display Body (Displayed when selected) -->
							<tr id="{{getIdForPeopleLocateBody(ui)}}" class="locateBody section-select">
								<td colspan="5" style="background-color: #2f2f2f">
									<table class="inner-table" style="background-color: #2f2f2f; border: 0">
										<tbody>
											<!-- User Image (Left side) -->
											<tr class="user-image" (click)="personHeaderClicked(ui)">
												<td rowspan="5">
													<img class="table-user-image"
														[src]="getImageSourceForObjectInstance(ui.person)" />
												</td>
											</tr>
											<ng-container *ngFor="let dataField of ui.person.data">
												<ng-container *ngIf="dataField.property.mainDisplay == true">
													<tr>
														<td></td>
														<td>{{ dataField.property.name }}: {{ dataField.value }}</td>
													</tr>
												</ng-container>
											</ng-container>
											<tr class="user-list">
												<td></td>
												<td><i class="fa fa-group" aria-hidden="true"></i> Groups:</td>
												<td>
													<ng-container *ngFor="let group of ui.person.groups">
														<button (click)="peopleGroupClicked(ui, group)"
															class="groupButton"
															[disabled]="isLocationMode">{{group.name}}</button>
													</ng-container>
												</td>
											</tr>
										</tbody>
									</table>
								</td>
							</tr>
						</ng-container>
					</tbody>
				</table>
				</div>
				<!-- Pagination Controls for the "People" Types (controls referenced in the *ngFor for the table data above) -->
				<pagination-controls class="pagination" id="peopletype_pagination" (pageChange)="onPageChange(mTabTypes.PEOPLE,$event)"
					[directionLinks]="true" nextLabel="Next" previousLabel="Prev" [autoHide]="true">
				</pagination-controls>
			</div>  
		</div>
		<!-- End of People Tab -->


		<!-- Assets Tab -->
		<div id="locate_assetsTab" class="tab-pane fade">

			<ng-container *ngIf="currentFilters[mTabTypes.ASSETS] && currentFilters[mTabTypes.ASSETS].length > 0">
				<div style="float: right" (click)="filterChosen(mTabTypes.ASSETS, null)">
					<i class="fa fa-close"></i>
				</div>
				<ng-container *ngFor="let currentAssetFilter of currentFilters[mTabTypes.ASSETS]">
					<div style="background-color: black; color: darkorange; align-content: center; padding-left: 20px">
						<i (click)="removeFilter(mTabTypes.ASSETS, currentAssetFilter)" style="color: red"
							class="fa fa-minus-circle"></i>&nbsp;<i class="fa fa-filter"></i>
						{{ currentAssetFilter.name }}
					</div>
				</ng-container>
			</ng-container>

			<!-- Assets Tab - Search Bar -->
			<div class="input-group locate-input">
				<input [(ngModel)]="mAssetSearchValue" (ngModelChange)="assetSearchValueChanged($event)"
					class="form-control" style="width: 75%; border: 0px solid;" placeholder="Search for something...">
				<select [(ngModel)]="mSelectedAssetSearchOption" (change)="assetSearchTypeChanged()" class="form-control" 
					style="width: 25%">
					<option *ngFor="let assetSearchOption of mAssetSearchOptions" [ngValue]="assetSearchOption">
						{{ getDisplayForAssetSearchOption(assetSearchOption) }}
					</option>
				</select>
			</div>

			<!--<div class="input-group locate-input">
				<input [(ngModel)]="mAssetSearchValue" (ngModelChange)="assetSearchValueChanged($event)"
					class="form-control" style="width: 75%; border: 0px solid;" placeholder="Search for something...">
				<select [(ngModel)]="mSelectedAssetSearchType" (change)="assetSearchTypeChanged()" class="form-control"
					style="width: 25%">
					<option *ngFor="let type of mSearchTypes" [ngValue]="type.value">
						{{type.title}}
					</option>
				</select>
			</div>-->

			<div class="locate-tab">
				<div class="locate-tab-scroll">
				<table class="table tablesorter tablesorter-default locate-table">

					<!-- Main Headers -->
					<tbody>
						<tr class="header">
							<th>
								<div class="checkbox checkbox-inline">
									<input type="checkbox" class="styled"
										[(ngModel)]="allAssetsSelected"
										(click)="selectAllAssets($event.target.checked)" >
									<label for="checkbox"></label>
								</div>
							</th>
							<th></th>
							<th>NAME</th>
							<th>LOCATION</th>
							<th>ZONE</th>
						</tr>
					</tbody>

					<!-- Asset Data -->
					<tbody id="locateTableAssets">

						<!-- Create the Displays for each Asset -->
						<ng-container *ngFor="let ui of mDisplayedAssetUis | paginate: {id: 'assettype_pagination', itemsPerPage: resultsPerPageValues, currentPage: currentAssetPage, totalItems: totalNumberOfAssets }">

							<!-- Main Label (Displayed when not selected) -->
							<tr id="{{getIdForAssetLocateHeader(ui)}}"
								[class.groupSelected]="isAssetGroupSelected(ui) || ui.selected" class="locateHeader">
								<td style="width: 16px">
									<div class="checkbox checkbox-inline">
										<input type="checkbox" class="styled"
											[(ngModel)]="ui.selected" 
											[disabled]="!ui.mAsset.locationInstance"
											(click)="selectAsset(ui, $event.target.checked)">
										<label></label>
									</div>
								</td>
								<td style="width: 16px" (click)="assetHeaderClicked(ui)">
									<img [src]="getIconSourceForObjectInstance(ui.mAsset)" />
								</td>
								<td (click)="assetHeaderClicked(ui)">
									{{ui.mAsset.name}}
								</td>
								<td (click)="assetHeaderClicked(ui)">
									<ng-container *ngIf="ui.mAsset.locationInstance != null">
										{{ui.mAsset.locationInstance.name }}
									</ng-container>
									<ng-container *ngIf="ui.mAsset.locationInstance == null">
										NOT PRESENT
									</ng-container>
								</td>
								<td (click)="assetHeaderClicked(ui)">
									<ng-container *ngIf="ui.mAsset.zoneInstance != null">
										{{ui.mAsset.zoneInstance.name }}
									</ng-container>
								</td>
							</tr>

							<!-- Display Body (Displayed when selected) -->
							<tr id="{{getIdForAssetLocateBody(ui)}}" class="locateBody"
								style="display: none; background-color: #2f2f2f">
								<td colspan="5">
									<table style="background-color: #2f2f2f; border: 0; width: 100%">
										<tbody>
											<tr class="user-image" (click)="assetHeaderClicked(ui)" *ngIf="isAssetImagePresent(ui.mAsset)">
												<td rowspan="10">
													<img class="table-user-image"
														[src]="getImageSourceForObjectInstance(ui.mAsset)" />
												</td>
											</tr>
											<tr class="user-list" (click)="assetHeaderClicked(ui)">
												<td>{{ui.mAsset.description}}</td>
											</tr>

											<!-- TJB 07/28/2022
												 Removed this per CMR's request. Will most likely need in the future.

											<ng-container *ngIf="ui.mAsset.position && ui.mAsset.position.z">
												<tr class="user-list" (click)="assetHeaderClicked(ui)">
													<td>Height:</td>
													<td>{{ getDisplayForMeasurement(ui.mAsset.position.z) }}</td>
												</tr>
											</ng-container>
											-->

											<ng-container *ngFor="let dataField of ui.mAsset.data">
												<ng-container *ngIf="dataField.property.mainDisplay == true">
													<tr>
														<td>{{ dataField.property.name }}:</td>
														<td style="max-width: 400px">
															<ng-container *ngIf="dataField.property.type == 'OBJECT_REFERENCE'">
																{{ objectReferenceName[dataField.value] }}
															</ng-container>
															<ng-container *ngIf="dataField.property.type == 'STRING'">
																<ng-container *ngIf="dataField.property.parameter == 'url'">
																	<a style="color: #e65100;" href="{{ dataField.value }}" target="_blank">{{ dataField.value }}</a>
																</ng-container>
																<ng-container *ngIf="dataField.property.parameter != 'url'">
																	{{ dataField.value }}
																</ng-container>
															</ng-container>
															<ng-container *ngIf="dataField.property.type != 'OBJECT_REFERENCE' && dataField.property.type != 'STRING'">
																{{ dataField.value }}
															</ng-container>
														</td>
													</tr>
												</ng-container>
											</ng-container>

											<tr class="user-list">
												<td><i class="fa fa-group" aria-hidden="true"></i> Groups:</td>
												<td>
													<ng-container *ngFor="let group of ui.mAsset.groups">
														<button (click)="assetGroupClicked(ui, group)"
															class="groupButton"
															[disabled]="isLocationMode">{{group.name}}</button>
													</ng-container>
												</td>
											</tr>
											
											<!-- Action(s) Button -->
											<tr>
												<td>
													<div class="dropdown btn-group" style="display:inline-block">
														<button type="button" class="btn btn-primary btn-xs dropdown-toggle" data-toggle="dropdown">Action(s)</button>
														<ul class="dropdown-menu">
															<li (click)="openAssetDataDialog(ui)"><a>Edit Data</a></li>
															<ng-container *ngIf="isAssetContainsFunctions(ui)">
																<li class="divider"></li>
																<ng-container *ngFor="let assetFunction of ui.mAsset.object.functions">
																	<li (click)="openAssetFunctionDialog(ui, assetFunction.key)"><a>{{ assetFunction.name }}</a></li>
																</ng-container>
															</ng-container>
														</ul>
													</div>
												</td>
												<td style="text-align: end; color:red;" class="locateBody">
													<ng-container *ngIf="isFullDetailsNeeded(ui)">
														<span id="{{getIdForAssetHideLocateDetails(ui)}}" style="display: none;" (click)="hideAssetFullDetails(ui)"> - Hide Full Details </span>
														<span id="{{getIdForAssetShowLocateDetails(ui)}}" (click)="showAssetFullDetails(ui)"> + Show Full Details </span>
													</ng-container>												
												</td>
											</tr>
										</tbody>
									</table>
								</td>
							</tr>

							<!-- Full Details Display -->
							<tr id="{{getIdForAssetLocateDetails(ui)}}" class="locateBody" *ngIf="isFullDetailsNeeded(ui)"
								style="display: none; background-color: #2f2f2f" >
								<td colspan="5">
									<table style="background-color: #2f2f2f; border: 0; width: 100%">
										<tbody>
											<ng-container *ngFor="let dataField of ui.mAsset.data">
												<ng-container *ngIf="dataField.property.mainDisplay == false">
													<tr>
														<td>{{ dataField.property.name }}:</td>
														<td style="max-width: 400px">
															<ng-container *ngIf="dataField.property.type == 'OBJECT_REFERENCE'">
																{{ objectReferenceName[dataField.value] }}
															</ng-container>
															<ng-container *ngIf="dataField.property.type == 'STRING'">
																<ng-container *ngIf="dataField.property.parameter == 'url'">
																	<a style="color: #e65100;" href="{{ dataField.value }}" target="_blank">{{ dataField.value }}</a>
																</ng-container>
																<ng-container *ngIf="dataField.property.parameter != 'url'">
																	{{ dataField.value }}
																</ng-container>
															</ng-container>
															<ng-container *ngIf="dataField.property.type != 'OBJECT_REFERENCE' && dataField.property.type != 'STRING'">
																{{ dataField.value }}
															</ng-container>
														</td>
													</tr>
												</ng-container>
											</ng-container>
										</tbody>
									</table>
								</td>
							</tr>
						</ng-container>
					</tbody>
				</table>
				</div>
				<!-- Pagination Controls for the "Assets" Types (controls referenced in the *ngFor for the table data above) -->
				<pagination-controls class="pagination" id="assettype_pagination" (pageChange)="onPageChange(mTabTypes.ASSETS, $event)"
					[directionLinks]="true" nextLabel="Next" previousLabel="Prev" [autoHide]="true">
				</pagination-controls>
			</div>
		</div>
		<!-- End of Assets Tab -->


		<!-- Vehicles Tab -->
		<div id="locate_vehiclesTab" class="tab-pane fade">

			<div class="input-group locate-input">
				<input type="text" style="width: 75%" id="locateInputVehicles" class="form-control"
					placeholder="Search for a vehicle...">
				<select id="locateNameGroupVehicles" class="form-control" style="width: 25%">
					<option value="NAME">NAME</option>
					<option value="GROUP">GROUP</option>
				</select>
			</div>

			<div class="locate-tab">
				<table class="table tablesorter tablesorter-default locate-table">
					<tbody>
						<tr class="header">
							<th>NAME</th>
							<th>LOCATION</th>
							<th>GROUPS</th>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
		<!-- End of Vehicles Tab -->

	</div>

</div>


<!-- Right Hand Side -->
<div class="col-sm-9"
	style="margin: -10px 0 0 0; padding: 0; height: calc(100vh - 50px); overflow-y: hidden; background-image: url(assets/images/map_bg.png)">
	<div class="well" style="margin-bottom: 0; opacity: 0.8; border-right: 0px; border-left: 0px;">

		<ng-container *ngFor="let shownLocation of shownLocations; let shownLocationNumber = index">
			<ng-container *ngIf="shownLocationNumber < NUM_LOCATION_TABS_SHOWN">
				<ng-container *ngIf="shownLocation.locationInstanceId == mSelectedLocation.id">
					<button type="button" class="btn btn-primary"
						(click)="clickLocationButtonSelectMode(shownLocation.locationInstanceId)">
						{{shownLocation == null? "" : shownLocation.locationInstanceName }}
						<span *ngIf="shownLocation.count > 0" class="badge badge-light badge-round">{{ shownLocation.count }}</span>
					</button>
				</ng-container>
				<ng-container *ngIf="shownLocation.locationInstanceId != mSelectedLocation.id">
					<button type="button" class="btn btn-secondary"
						(click)="clickLocationButtonSelectMode(shownLocation.locationInstanceId)">
						{{shownLocation == null? "" : shownLocation.locationInstanceName }}
						<span *ngIf="shownLocation.count > 0" class="badge badge-light badge-round">{{ shownLocation.count }}</span>
					</button>
				</ng-container>
			</ng-container>
		</ng-container>

		<ng-container *ngIf="shownLocations.length > NUM_LOCATION_TABS_SHOWN">
			<span class="dropdown">
				<button type="button" class="btn btn-secondary dropdown-toggle" id="dropDownMenuButton"
					data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">...</button>
				<div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
					<ng-container *ngFor="let shownLocation of shownLocations; let shownLocationNumber = index">
						<ng-container *ngIf="shownLocationNumber >= NUM_LOCATION_TABS_SHOWN">
							<a class="dropdown-item"
								(click)="clickLocationButtonSelectMode(shownLocation.locationInstanceId)">
								{{ shownLocation.locationInstanceName}}</a>
						</ng-container>
					</ng-container>
				</div>
			</span>
		</ng-container>

	</div>

	<!-- Canvas where everything is drawn -->
	<app-map #locateMap class="locate-map" [location]="mSelectedLocation" [displayMenu]="true"
		(mappingEvent)="mappingEventEmitted($event)" (assetPositionChangedEvent)="assetPositionChangedEventEmitted($event)"></app-map>

</div><!-- end of col-sm-8 -->

<!-- Popup Dialog used to execute Function Action(s) on Assets -->
<ef-instance-function-popup
	(functionCompletedSuccessfullyEvent)="onAssetFunctionCompletedSuccessfully($event)"
	>
</ef-instance-function-popup>

<!-- Popup Dialog used execute the "Edit Data" Action on Assets -->
<ef-instance-data-dialog
	(updateCompletedSuccessfullyEvent)="onAssetDataUpdatedSuccessfully($event)"
	>
</ef-instance-data-dialog>